class Portfolio {
    init() {
        this.personalDataRevealerClassName = "personal-data-revealer";

        this.revealPersonalData();
    }

    revealPersonalData() {
        const revealers = document.querySelectorAll(
            `.contact-details .${this.personalDataRevealerClassName}`
        );

        revealers?.forEach(revealer => {
            revealer.addEventListener("click", () => {
                const actualDataHandler = revealer.parentElement.querySelector(
                    ".actual-data"
                );
                revealer.remove();
                actualDataHandler.classList.remove("d-none");
            });
        });
    }
}

export default Portfolio;
